import axios from "axios";
import { message as AntdAlert } from "antd";
import { put } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";

export function* handleFetchRevisionStatuses({ data }) {
  try {
    const response = yield axios.get(`${baseURL}/api/v1/revision_statuses`, {
    });
    const { success } = response.data;
    if (success) {
      yield put(actions.fetchRevisionStatusesSuccess(response.data.data));
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchRevisionStatusesError());
    AntdAlert.error("Something went wrong!");
    console.log(error);
  }
}

export function* handleUpdateRevisionStatuses({ data }) {
  const { color, id, show_by_default, status_name } = data;

  try {
    const response = yield axios.put(
      `${baseURL}/api/v1/revision_statuses/${id}`,
      {
        show_by_default,
        status_name,
        color,
      }
    );
    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateRevisionStatusesSuccess(data));
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.updateRevisionStatusesError(response.data.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateRevisionStatusesError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleDeleteRevisionStatuses({ data }) {
  const { id } = data;
  try {
    const response = yield axios.delete(
      `${baseURL}/api/v1/revision_statuses/${id}`
    );
    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(actions.deleteRevisionStatusesSuccess(id));
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.deleteRevisionStatusesError(response.data.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.deleteRevisionStatusesError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleCreateRevisionStatuses({ data }) {
  try {
    const newData = JSON.parse(JSON.stringify(data));
    delete newData.id;
    const response = yield axios.post(`${baseURL}/api/v1/revision_statuses`, {
      ...newData,
    });
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.createRevisionStatusesSuccess(response.data.data));
    } else if (!success) {
      AntdAlert.error(response.data?.errors[0]);
      yield put(actions.createRevisionStatusesError(data.id));
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleUpdateRevisionOrder({ data }) {
  console.log("handleUpdateRevisionOrder", data);

  const fd = new FormData();
  data.map((el, i) => fd.append(`revision_status[${el.id}]`, i + 1));

  try {
    const response = yield axios.patch(
      `${baseURL}/api/v1/revision_statuses/sort`,
      fd
    );
    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateRevisionsOrderSuccess(data));
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.updateRevisionsOrderError());
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateRevisionsOrderError());
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}
